__turbopack_context__.v({
  "generatingItem": "index-module__DxJnfW__generatingItem",
});
